// extracted by mini-css-extract-plugin
export default {"table":"checkoutCardTable_table__f1QR-","cards":"checkoutCardTable_cards__Uz0v7"};